// extracted by mini-css-extract-plugin
export default {"busyIndicatorContainer":"g2__BUUKbd"};